module.exports = __webpack_public_path__ + "static/img/free-bg.1e2d51c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hlSaled-2025/free-bg.png
// module id = eafN
// module chunks = 1